module.exports = __webpack_public_path__ + "static/media/invoice_template.0cb74249.docx";